import { Button } from '@clds/button';
import { messages } from '../../i18n/upgradeModalMessages';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { useAnalytics } from '@cld/analytics';
import { useCustomerIdContext } from '../../context';
import { useAccountInfoData } from './usePopupModal';

const STARS_IMG = 'https://res.cloudinary.com/prod/image/upload/upgrade-popup-modal/stars.png';
const ButtonsContainer = styled.div`
  display: flex;
  margin-top: ${(props) => props.theme.spacing.lg};
  gap: ${(props) => props.theme.spacing.xs};
`;

const IconImage = styled.img<{ size: 'md' | 'sm' | 'xs' }>`
  width: ${({ size, theme }) => theme.font.size[size]};
  border-radius: ${(props) => props.theme.radius.md};
  vertical-align: center;
`;
interface ModalAnalytics {
  category: string;
  label: string;
  action: string;
}
interface UpgradeButtonsProps {
  upgradeOptionsAnalytics: ModalAnalytics;
  accountManagementAnalytics: ModalAnalytics;
  modelPopupKind: 'addProductEnvModal' | 'addUserModal';
}
export const UpgradeButtons = ({ upgradeOptionsAnalytics, accountManagementAnalytics, modelPopupKind }: UpgradeButtonsProps) => {
  const { currentCustomer } = useCustomerIdContext();
  const customerId = currentCustomer?.externalIdForUrl || '';
  const UPGRADE_OPTIONS_LINK = `/pm${customerId}/upgrade_options`;
  const NEW_BILLING_LINK = `/settings${customerId}/billing/change_plan/programmable_media`;
  const ACCOUNT_MANAGEMENT_LINK = `/settings${customerId}/account`;
  const USER_MANAGEMENT_LINK = `/settings${customerId}/user-management`;
  const analytics = useAnalytics(upgradeOptionsAnalytics.category);

  const { formatMessage } = useIntl();
  const accountInfoData = useAccountInfoData();

  return (
    <ButtonsContainer>
      <Button
        data-testid="upgrade-options-button"
        size={'md'}
        variant={'primary'}
        leftSlot={<IconImage size="sm" src={STARS_IMG} />}
        onClick={() => {
          window.location.href = accountInfoData?.iseNewBilling ? NEW_BILLING_LINK : UPGRADE_OPTIONS_LINK;
          analytics(upgradeOptionsAnalytics.label, upgradeOptionsAnalytics.action);
        }}
      >
        {formatMessage(messages.upgradeOptionsButton)}
      </Button>
      {modelPopupKind === 'addUserModal' && (
        <Button
          data-testid="user-management-button"
          size={'md'}
          tone={'surface'}
          onClick={() => {
            window.location.href = USER_MANAGEMENT_LINK;
            analytics(accountManagementAnalytics.label, accountManagementAnalytics.action);
          }}
        >
          {formatMessage(messages.userManagementButton)}
        </Button>
      )}
      {modelPopupKind === 'addProductEnvModal' && (
        <Button
          data-testid="account-management-button"
          size={'md'}
          tone={'surface'}
          onClick={() => {
            window.location.href = ACCOUNT_MANAGEMENT_LINK;
            analytics(accountManagementAnalytics.label, accountManagementAnalytics.action);
          }}
        >
          {formatMessage(messages.accountManagementButton)}
        </Button>
      )}
    </ButtonsContainer>
  );
};
